/* Current privacy-policy version. Must match the Version string in
   docs/legal/privacy-policy.md — it is recorded with every consent. */
export const POLICY_VERSION = "2026-07-b";
